const HOME = '/';
const ABOUT = '/about';
const WORKS = '/works';
const CONTACT = '/contact';

const routes = { HOME, ABOUT, WORKS, CONTACT };
export default routes;
